import React, { useContext, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";

import { GlobalContext } from "../context/GlobalContext";

export default function Navbar({ aboutSidebar }) {
  const { state, handleFunction } = useContext(GlobalContext);
  const { toggleNavbar, setSidebar, sideBarOn } = state;
  const { navbarButton, sidebarButton, navbarClose, doubleClose } =
    handleFunction;

  useEffect(() => {
    setSidebar(aboutSidebar);
  }, [aboutSidebar, setSidebar]);

  return (
    <nav className="max-lg:shadow-sm max-lg:border-b py-4 lg:py-8 px-6 sm:px-8 md:px-12 lg:px-20 xl:px-24 fixed max-w-screen-2xl mx-auto inset-x-0 z-50 top-0 left-0 bg-mesanfaz-gray">
      <div className="flex flex-wrap items-center justify-between">
        {sideBarOn && (
          <button
            type="button"
            className="rounded-lg lg:hidden hover:bg-gray-100"
            onClick={sidebarButton}
          >
            <span className="sr-only">Open Sidebar</span>
            <svg
              className="w-6 h-6"
              aria-hidden="true"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                clip-rule="evenodd"
                fill-rule="evenodd"
                d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
              ></path>
            </svg>
          </button>
        )}
        <Link
          to={{ pathname: "/" }}
          onClick={doubleClose}
          className="flex items-center"
        >
          <img src={process.env.PUBLIC_URL + "/mesanfaz.png"} alt="mesanfaz" />
        </Link>
        <button
          type="button"
          className="rounded-lg lg:hidden hover:bg-gray-100"
          onClick={navbarButton}
        >
          <span className="sr-only">Open Main Menu</span>
          <svg
            className="w-6 h-6"
            aria-hidden="true"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
        <div
          className={
            "items-center justify-between w-full lg:flex lg:w-auto" +
            (toggleNavbar ? " " : " hidden")
          }
        >
          <ul className="flex flex-col p-4 lg:p-0 mt-4 border rounded-lg lg:flex-row lg:space-x-16 xl:space-x-20 2xl:space-x-24 lg:mt-0 lg:border-0">
            <li>
              <NavLink
                key="home"
                to="/"
                onClick={navbarClose}
                className={({ isActive }) => {
                  return (
                    "block py-2 pl-3 pr-4 no-underline rounded lg:p-0 underline-offset-8 decoration-2 " +
                    (!isActive
                      ? "hover:bg-gray-100 lg:hover:underline lg:hover:bg-transparent"
                      : "bg-gray-200 lg:underline lg:bg-transparent")
                  );
                }}
              >
                🏠 home
              </NavLink>
            </li>
            <li>
              <NavLink
                key="about"
                to="/about"
                onClick={navbarClose}
                className={({ isActive }) => {
                  return (
                    "block py-2 pl-3 pr-4 no-underline rounded lg:p-0 underline-offset-8 decoration-2 " +
                    (!isActive
                      ? "hover:bg-gray-100 lg:hover:underline lg:hover:bg-transparent"
                      : "bg-gray-200 lg:underline lg:bg-transparent")
                  );
                }}
              >
                🧑 about
              </NavLink>
            </li>
            <li>
              <NavLink
                key="projects"
                to="https://linktr.ee/mesanfaz"
                target="_blank"
                onClick={navbarClose}
                className={({ isActive }) => {
                  return (
                    "block py-2 pl-3 pr-4 no-underline rounded lg:p-0 underline-offset-8 decoration-2 " +
                    (!isActive
                      ? "hover:bg-gray-100 lg:hover:underline lg:hover:bg-transparent"
                      : "bg-gray-200 lg:underline lg:bg-transparent")
                  );
                }}
              >
                💻 projects
              </NavLink>
            </li>
            <li>
              <NavLink
                key="contact"
                to="/contact"
                onClick={navbarClose}
                className={({ isActive }) => {
                  return (
                    "block py-2 pl-3 pr-4 no-underline rounded lg:p-0 underline-offset-8 decoration-2 " +
                    (!isActive
                      ? "hover:bg-gray-100 lg:hover:underline lg:hover:bg-transparent"
                      : "bg-gray-200 lg:underline lg:bg-transparent")
                  );
                }}
              >
                📞 contact
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
